import { render, staticRenderFns } from "./UnterrichtAdditionalKnowledgeForA.vue?vue&type=template&id=03dbf334&scoped=true"
import script from "./UnterrichtAdditionalKnowledgeForA.vue?vue&type=script&lang=ts"
export * from "./UnterrichtAdditionalKnowledgeForA.vue?vue&type=script&lang=ts"
import style0 from "./UnterrichtAdditionalKnowledgeForA.vue?vue&type=style&index=0&id=03dbf334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dbf334",
  null
  
)

export default component.exports